import { render, staticRenderFns } from "./NavigateWithSelector.vue?vue&type=template&id=6d01d9a8&scoped=true"
import script from "./NavigateWithSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigateWithSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NavigateWithSelector.vue?vue&type=style&index=0&id=6d01d9a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d01d9a8",
  null
  
)

export default component.exports